import React, { useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  Divider,
  Flex,
  Select,
  SimpleGrid,
  createStyles,
  rem,
} from "@mantine/core";
import ActionButtons from "./ActionButtons";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { useSelector } from "react-redux";
import { getAllTimezonesWithAbbr } from "../../utils";

const useStyles = createStyles((theme) => ({}));

export const FacilitySettingsTab = ({
  mode,
  form,
  handleSave,
  handleCancel,
  loading,
  ...data
}) => {
  const { classes } = useStyles();
  const [noClockIn, setNoClockIn] = useState("");

  const { allFacilityTypes, loadingAddFacility } = useSelector(
    (state) => state.facility
  );
  const DropDownArrow = (
    <DropDownArrowSvg
      color={"#FBAA0D"}
      style={{ width: rem(1), height: rem(1) }}
    />
  );

  useEffect(() => {
    setNoClockIn((!form?.values?.checkInType || form?.values?.checkInType === "no-clockin") ? true : false);
    if(!form?.values?.checkInType){
      form.setFieldValue("checkInType", "no-clockin");
    }
  }, []);

  const handleNoClockInChange = (event) => {
    const checked = event.currentTarget.checked;
    setNoClockIn(checked);
    if (checked) {
      form.setFieldValue("checkInType", "no-clockin");
    } else {
      form.setFieldValue("checkInType", null);
    }
  };

  return (
    <Box className={classes.FacilityDetailsTab}>
      <form onSubmit={form.onSubmit(handleSave)}>
        <Box className={classes.facilityForm}>
          <SimpleGrid
            cols={2}
            className={classes.mwd}
            sx={{
              paddingTop: 20,
            }}
          >
            <Select
              id="facility-type"
              searchable
              size="md"
              radius={"md"}
              label="Facility Type"
              data={
                allFacilityTypes?.ftypes?.map((val) => ({
                  value: val?.id,
                  label: val?.name,
                })) || []
              }
              rightSection={DropDownArrow}
              placeholder="Select Facility Type"
              {...form.getInputProps("type")}
              disabled={mode == "view" ? true : false}
            />
            <Flex direction="column" gap={10}>
              <Select
                id="clock-in-location"
                searchable
                size="md"
                radius="md"
                label="Clock-in Location"
                data={[
                  { value: "facility", label: "Facility" },
                  { value: "client", label: "Client" },
                ]}
                rightSection={DropDownArrow}
                placeholder="Select Clock-in Location"
                {...form.getInputProps("checkInType")}
                disabled={mode === "view" || noClockIn}
              />
              <Checkbox
                color="gray"
                label="No Clock-in"
                checked={noClockIn}
                onChange={handleNoClockInChange}
                disabled={mode === "view"}
              />
            </Flex>
          </SimpleGrid>
          <SimpleGrid
            cols={2}
            className={classes.mwd}
            sx={{
              paddingTop: 20,
            }}
          >
            <Select
              id="facility-type"
              searchable
              size="md"
              radius={"md"}
              label="EVV Required"
              data={[
                { value: "yes", label: "Yes" },
                { value: "no", label: "No" },
              ]}
              rightSection={DropDownArrow}
              placeholder="Select EVV Required"
              {...form.getInputProps("evvRequired")}
              disabled={mode == "view" ? true : false}
            />
            <Select
              label="Timezone"
              id="staff-Role"
              disabled={mode == "view" ? true : false}
              searchable
              size="md"
              radius={"md"}
              placeholder="Select Timezone"
              rightSection={DropDownArrow}
              data={getAllTimezonesWithAbbr()}
              {...form.getInputProps("timeZone")}
            />
          </SimpleGrid>
          <SimpleGrid cols={2} className={classes.mwd}
            sx={{
              paddingTop: 20,
            }}>
            <Select
              id="skai-access"
              searchable
              size="md"
              radius={"md"}
              label="SkAi Access"
              data={[
                { value: true, label: "Yes" },
                { value: false, label: "No" },
              ]}
              rightSection={DropDownArrow}
              placeholder="Select SkAi Access"
              {...form.getInputProps("skaiAccess")}
              disabled={mode == "view" ? true : false}
            />
          </SimpleGrid>
        </Box>

        {(mode === "add" || mode === "edit") && (
          <Box mt={40}>
            <Divider my={10} />
            <ActionButtons
              onCancel={handleCancel}
              type="submit"
              loading={loading}
              isFacility={true}
              // onSave={handleSave}
            />
          </Box>
        )}
      </form>
    </Box>
  );
};
